import * as Yup from "yup";

export const RoleSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  permissionIds: Yup.array().min(1, "At least one permission is required"),
});
